import {
  aClient,
  aMapFilters,
  aMapStyle,
  useAtom,
  useAtomValue,
} from 'app/atoms'
import { Button } from 'app/components/ui'
import {
  LucideBuilding2,
  LucideHome,
  LucideZoomIn,
  LucideZoomOut,
} from 'lucide-react'
import { useMemo } from 'react'
import { useMap } from 'react-map-gl'
import { useNavigate } from 'react-router'
import { ControlTooltip } from '~/components/common'
import { useIsSafari } from '~/hooks/browser'
import { cn } from '~/lib'

export default function MapViewControls() {
  const client = useAtomValue(aClient)
  const mapRef = useMap()
  const [mapStyle, setMapStyle] = useAtom(aMapStyle)
  const mapFilters = useAtomValue(aMapFilters)
  const isSafari = useIsSafari()

  const navigate = useNavigate()

  const setInitialView = (e: React.MouseEvent) => {
    e.preventDefault()
    if (!client) return

    // setSelectedListing(null)
    navigate('/')
    mapRef.current!.flyTo({
      zoom: client!.initial_state.zoom,
      center: [client!.initial_state.longitude, client!.initial_state.latitude],
      // padding: { left: mapCardSizes.list, top: 0, right: 0, bottom: 0 },
      bearing: 0,
      pitch: 0,
      duration: 500,
    })
  }

  const zoomIn = (e: React.MouseEvent) => {
    e.preventDefault()
    mapRef.current!.flyTo({
      zoom: mapRef.current!.getZoom() + 1,
      center: mapRef.current!.getCenter(),
      //   padding: { left: mapCardSizes.list, top: 0, right: 0, bottom: 0 },
      bearing: 0,
      pitch: 0,
      duration: 500,
    })
  }

  const zoomOut = (e: React.MouseEvent) => {
    e.preventDefault()
    mapRef.current!.flyTo({
      zoom: mapRef.current!.getZoom() - 1,
      center: mapRef.current!.getCenter(),
      //   padding: { left: mapCardSizes.list, top: 0, right: 0, bottom: 0 },
      bearing: 0,
      pitch: 0,
      duration: 500,
    })
  }

  const isBuildingToggled = useMemo(() => {
    return (
      (mapFilters.b && mapFilters.b != '0') ||
      (mapFilters.p && mapFilters.p != '0')
    )
  }, [mapFilters])

  const toggleBuildingView = (e: any) => {
    e.preventDefault()
    if (
      mapRef.current!.getPitch() !== 0 ||
      mapRef.current!.getBearing() !== 0
    ) {
      mapRef.current!.flyTo({
        zoom: mapRef.current!.getZoom(),
        center: mapRef.current!.getCenter(),
        duration: 500,
        pitch: 0,
        bearing: 0,
      })
    } else {
      setMapStyle('street')
      mapRef.current!.flyTo({
        zoom: mapRef.current!.getZoom() < 15 ? 15 : mapRef.current!.getZoom(),
        center: mapRef.current!.getCenter(),
        duration: 500,
        pitch: 45,
      })
    }
  }

  return (
    <>
      <ControlTooltip text="Map home">
        <Button id="map-home" variant="map" size="map" onClick={setInitialView}>
          <LucideHome className="h-5 w-5" />
        </Button>
      </ControlTooltip>

      <ControlTooltip text="Zoom in">
        <Button id="map-zoom-in" variant="map" size="map" onClick={zoomIn}>
          <LucideZoomIn className="h-5 w-5" />
        </Button>
      </ControlTooltip>
      <ControlTooltip text="Zoom out">
        <Button id="map-zoom-out" variant="map" size="map" onClick={zoomOut}>
          <LucideZoomOut className="h-5 w-5" />
        </Button>
      </ControlTooltip>
      {!isSafari && (
        <ControlTooltip text="Toggle buildings view">
          <Button
            id="map-buildings"
            variant="map"
            size="map"
            className={cn(isBuildingToggled && 'bg-primary text-white')}
            onClick={toggleBuildingView}>
            <LucideBuilding2 className="h-5 w-5" />
          </Button>
        </ControlTooltip>
      )}
      <ControlTooltip
        text={mapStyle === 'street' ? 'View satellite map' : 'View street map'}>
        <Button
          id="map-style"
          variant="map"
          size="map"
          className=""
          onClick={() => {
            setMapStyle(mapStyle === 'street' ? 'satellite' : 'street')
          }}>
          <img
            className="w-full rounded-md"
            src={mapStyle === 'street' ? '/satellite.png' : '/street.png'}
            alt={mapStyle === 'street' ? 'Select Satellite' : 'Select Street'}
          />
        </Button>
      </ControlTooltip>
    </>
  )
}
